<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <!--日期、銀行帳號、金額、備註、照片x1-->
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <input
                  ref="fileInput"
                  hidden
                  type="file"
                  accept="image/*"
                  @change="onImageFileChanged"
                />
                <v-img
                  v-if="!form.ImageURL && !form.newImage.blobURL"
                  style="cursor:pointer;"
                  @click="requestUploadImage"
                  src="@/assets/img/placeholder-image-upload.png"
                  aspect-ratio="1.5"
                  cover
                ></v-img>
                <v-img
                  v-else
                  @click="requestUploadImage"
                  style="cursor:pointer;"
                  :src="form.ImageURL || form.newImage.blobURL"
                  aspect-ratio="1.5"
                  contain
                ></v-img>

                <v-select
                  :items="typeOptions"
                  item-text="Name"
                  item-value="ID"
                  label="種類"
                  v-model="form.Type"
                ></v-select>
                <v-text-field
                  v-model="form.BankAccount"
                  label="銀行帳號"
                ></v-text-field>
                <v-text-field
                  v-model="form.Amount"
                  label="金額"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :rules="formRules.amount"
                ></v-text-field>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedDate"
                      clearable
                      label="日期"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.Date"
                    @change="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  v-model="form.Remark"
                  label="備註"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ImageThumbnailer from "@/utils/ImageThumbnailer.js";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    },
    projectId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    form: {
      newImage: {}
    },
    defaultForm: { newImage: {}, Type: "issued" },
    dateMenu: false,
    // options
    typeOptions: [
      { ID: "issued", Name: "開立的發票(收入)" },
      { ID: "received", Name: "收到的發票(支出)" }
    ]
  }),
  computed: {
    formRules() {
      return {
        amount: [
          v => !!v || "請輸入金額",
          v => parseInt(v) <= 1000000000 || "金額不可超過10億"
        ]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    formattedDate() {
      return this.form.Date ? moment(this.form.Date).format("LLL") : "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    project() {
      return this.$store.state.project.list.find(o => o.ID == this.projectId);
    },
    editingIdx() {
      return this.project.Receipts.findIndex(o => o.ID == this.editingId);
    }
  },
  methods: {
    requestUploadImage() {
      this.$refs.fileInput.click();
    },
    onImageFileChanged() {
      let opt = {
        maxWidth: 512,
        maxHeight: 512
      };
      var newImageFile = this.$refs.fileInput.files[0];
      this.form.newImage.file = newImageFile;
      ImageThumbnailer.shared.requestCompress(
        newImageFile,
        blob => {
          this.$set(this.form.newImage, "compressedBlob", blob);
          this.$set(this.form.newImage, "blobURL", URL.createObjectURL(blob));
        },
        opt
      );
    },
    close() {
      this.isShowDialog = false;
    },
    uploadNewImageIfExists() {
      if (!this.form.newImage || !this.form.newImage.file)
        return new Promise((resolve, reject) => resolve());

      var fileName = this.form.newImage.file.name;
      var arr = fileName.split(".");
      var fileExtension = arr[arr.length - 1];

      return this.$services.firebase
        .upload(
          this.form.newImage.compressedBlob,
          "project/" + this.projectId + "/receipt",
          "jpg"
        )
        .then(url => {
          if (url) {
            this.form.ImageURL = url;
            if (this.form.newImage.url) {
              URL.revokeObjectURL(this.form.newImage.url);
            }
            this.form.newImage = {};
          }
        });
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.form.Amount = parseInt(this.form.Amount) || 0;
      if (this.editingId < 0) this.form.ProjectID = this.projectId;
      if (this.form.Amount > 1000000000) {
        return alert("發票金額不可大於10億");
      }

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.uploadNewImageIfExists()
          .then(() => {
            let payload = JSON.parse(JSON.stringify(this.form));
            if (payload.Date)
              payload.Date = moment(payload.Date).toISOString(true);
            return this.$services.receipt.edit(this, payload);
          })
          .then(res => {
            this.$set(this.project.Receipts, this.editingIdx, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.uploadNewImageIfExists()
          .then(() => {
            let payload = JSON.parse(JSON.stringify(this.form));
            if (payload.Date)
              payload.Date = moment(payload.Date).toISOString(true);
            return this.$services.receipt.add(this, payload);
          })
          .then(res => {
            this.project.Receipts.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        let data = JSON.parse(
          JSON.stringify(this.project.Receipts[this.editingIdx])
        );
        data.newImage = {};
        this.form = data;
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.$set(this.form, "Date", new Date());
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>